<template>
  <!-- <h1 class="fs-3 m-0 ps-5 py-2">{{ this.title }}</h1> -->
  <div v-if="!country_zoomed"
    class="header-container d-flex align-items-center justify-content-center position-relative">
    <h2 class="fs-4 text-center w-75 my-5 mx-auto" v-html="this.subtitle"></h2>
    <div class="button-container position-absolute end-0">
      <button @click="bulkdownload"
        class="download_alldata d-flex align-items-center justify-content-center border border-0 text-white"
        :class="{ hovered: isHovered }">
        <span class="fs-6">Download data</span>
      </button>
    </div>
  </div>
  <div v-if="!country_zoomed" class="hello helloCountryMap mt-1 w-100 bg-white" id="chartdivMapOpportunity">
  </div>
  <div v-if="country_zoomed" class="hello helloCountryMap mt-1 w-100 bg-white" id="chartdivMapOpportunity"
    style="height: 350px">
  </div>
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4maps from "@amcharts/amcharts4/maps";
import am4geodata_worldLow from "@amcharts/amcharts4-geodata/worldLow";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import globalVar from "@/assets/globalVar.json"

/* eslint-disable */
import { countryToAlpha3 } from "country-to-iso";

export default {
  data() {
    return {
      selectedCountry: { id: '', value: 0 },
    }
  },
  props: {
    map: {
      type: Object,
      required: true,
    },
    country: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: true,
    },
    country_zoomed: {
      type: String,
      required: false
    }
  },
  methods: {
    bulkdownload() {
      const link = document.createElement('a');
      link.href = './risk_opport_decomposition.xlsx'
      link.download = 'risk_opport_decomposition.xlsx';
      link.click();
    },
    getColor(value) {
      /*const ranges = [1, 1.5, 2, 2.5, 3, 3.5, 4, 5];
      const colors = ['#005c00', '#029602', '#3be33b', '#ffd700', '#f59218', '#ff0000', '#cc0000'];*/
      // const ranges = [1, 2.001, 2.49, 2.99, 3.99, 5];
      // const colors = ['#cfe5fd', '#89a8e8', '#506fc4', '#9b7ac7', '#6a4c9c'];
      let rangesData = globalVar.opport
      let category = '';
      if (value >= 5) {
        category = rangesData[4].color;
      } else {
        category = '#808080'
        for (let i = 0; i < rangesData.length; i++) {
          if (value >= rangesData[i].rangeMin - 0.005 && value <= rangesData[i].rangeMax - 0.005) {
            category = rangesData[i].color;
            break;
          }
        }
      }
      return category;
    },
    handleHit(ev) {
      if (ev.target.dataItem.dataContext.value !== undefined) {
        let cntname = ev.target.dataItem.dataContext.name;
        if (cntname == "Palestinian Territories") {
          cntname = "Palestine"
        }
        const url = '/country/' + cntname;
        window.location.href = url;
      }
    },
    modifyCountryToAlpha3(countryIdOrName) {
      const originalCountryToAlpha3 = countryToAlpha3;
      if ((countryIdOrName === 'KSV') | (countryIdOrName === 'Kosovo') | (countryIdOrName === 'XK')) {
        return 'KSV';
      } else {
        return originalCountryToAlpha3(countryIdOrName);
      }
    },
    GetCountry() {
      this.countryIn = this.modifyCountryToAlpha3(this.$route.params.element);
      if (this.map.hasOwnProperty(this.countryIn)) {
        this.selectedCountry.id = this.map[this.countryIn].name;
        this.selectedCountry.value = this.map[this.countryIn].opportunity;
      }
    },
    renderChart() {
      am4core.useTheme(am4themes_animated);
      let chart = am4core.create("chartdivMapOpportunity", am4maps.MapChart);

      chart.geodata = am4geodata_worldLow;

      chart.projection = new am4maps.projections.Miller();
      chart.homeGeoPoint = {
        latitude: 30, // Keep it centered vertically
        longitude: 50 // Shift to the left horizontally, adjust this value as needed
      };
      let polygonSeries = chart.series.push(new am4maps.MapPolygonSeries());

      polygonSeries.useGeodata = true;
      polygonSeries.calculateVisualCenter = true;

      const mapData = Object.values(this.map).map(item => ({
        id: item.name,
        value: item.opportunity,
        value_str: item.opportunity > 0 ? (Math.round(item.opportunity * 100) / 100).toFixed(2) : '',
        fill: am4core.color(this.getColor(item.opportunity)),
      }));


      polygonSeries.data = mapData;
      if (this.country_zoomed) {
        if (this.country_zoomed == "RU") {
          chart.deltaLongitude = -10;
        }
      }

      if (!this.country_zoomed) {

        let rangesData = globalVar.opport
        var legend = new am4maps.Legend();
        legend.parent = chart.chartContainer;
        legend.background.fill = am4core.color("#000");
        legend.background.fillOpacity = 0.05;
        legend.width = 275;
        legend.align = "right";
        legend.padding(10, 15, chart.chartContainer.maxHeight, 15);
        legend.data = [{
          "name": `${rangesData[0].indicator} (${rangesData[0].rangeMin.toFixed(2)} to ${(rangesData[0].rangeMax - 0.01).toFixed(2)})`,
          "fill": rangesData[0].color
        }, {
          "name": `${rangesData[1].indicator} (${rangesData[1].rangeMin.toFixed(2)} to ${(rangesData[1].rangeMax - 0.01).toFixed(2)})`,
          "fill": rangesData[1].color
        }, {
          "name": `${rangesData[2].indicator} (${rangesData[2].rangeMin.toFixed(2)} to ${(rangesData[2].rangeMax - 0.01).toFixed(2)})`,
          "fill": rangesData[2].color
        }, {
          "name": `${rangesData[3].indicator} (${rangesData[3].rangeMin.toFixed(2)} to ${(rangesData[3].rangeMax - 0.01).toFixed(2)})`,
          "fill": rangesData[3].color
        }, {
          "name": `${rangesData[4].indicator} (${rangesData[4].rangeMin.toFixed(2)} to ${(rangesData[4].rangeMax).toFixed(2)})`,
          "fill": rangesData[4].color
        },
        {
          "name": "no/partial assessment \ndue to lack of data",
          "fill": "#808080"
        }];
        legend.itemContainers.template.clickable = false;
        legend.itemContainers.template.focusable = false;

        var legendTitle = legend.createChild(am4core.Label);
        legendTitle.text = "Opportunity level :";
      }

      let polygonTemplate = polygonSeries.mapPolygons.template;
      polygonTemplate.applyOnClones = true;
      polygonTemplate.togglable = true;
      polygonTemplate.tooltipText = "{name} : {value_str}";
      polygonTemplate.nonScalingStroke = true;
      polygonTemplate.strokeOpacity = 0.5;
      polygonTemplate.fill = 'rgb(128, 128, 128)';
      polygonTemplate.cursorOverStyle = am4core.MouseCursorStyle.pointer;
      polygonTemplate.events.on("hit", this.handleHit);
      polygonTemplate.propertyFields.fill = "fill";

      polygonSeries.exclude = ["AQ"];
      chart.exporting.menu = new am4core.ExportMenu();
      chart.exporting.filePrefix = 'GlobalOpportunity'
      chart.exporting.menu.align = "left";
      chart.exporting.menu.verticalAlign = "top";



      var labelSeries = chart.series.push(new am4maps.MapImageSeries());
      var label = labelSeries.mapImages.template.createChild(am4core.Label);
      label.text = "aaaaa";
      label.strokeOpacity = 0;
      label.fill = am4core.color("#000000");
      label.horizontalCenter = "middle";
      label.fontSize = 9;
      label.nonScaling = true;


      if (this.country_zoomed) {
        let labelSeries = chart.series.push(new am4maps.MapImageSeries());
        let labelTemplate = labelSeries.mapImages.template.createChild(am4core.Label);
        labelTemplate.horizontalCenter = "middle";
        labelTemplate.verticalCenter = "middle";
        labelTemplate.fontSize = 14;
        labelTemplate.nonScaling = true;
        labelTemplate.interactionsEnabled = false;

        const excluded_countries = ["Andorra", "Guernsey", "Jersey", "Faroe Islands", "Christmas Island", "British Indian Ocean Territory", "Seychelles", "Saint Helena", "Johnston Atoll", "Kiribati", "Jarvis Island", "Niue", "French Polynesia", "Cook Islands", "Pitcairn Islands", "San Marino", "Vatican City", "Gibraltar", "Monaco", "Saint Pierre and Miquelon", "Liechtenstein", "Isle of Man"]

        polygonSeries.events.on("inited", () => {
          polygonSeries.mapPolygons.each(function (polygon) {
            let label = labelSeries.mapImages.create();
            label.latitude = polygon.visualLatitude;
            label.longitude = polygon.visualLongitude;
            let name = polygon.dataItem.dataContext.name
            if (!excluded_countries.includes(name)) {
              label.children.getIndex(0).text = polygon.dataItem.dataContext.name;

            }
          });
        });



      }


      if (this.country_zoomed) {
        setTimeout(() => {
          chart.zoomToMapObject(polygonSeries.getPolygonById(this.country_zoomed));
        }, 1500)

        let button = chart.chartContainer.createChild(am4core.Button);
        button.label.text = "-";
        button.padding(5, 5, 5, 5);
        button.width = 30;

        button.align = "right";
        button.marginRight = 15;
        button.events.on("hit", () => {
          chart.zoomToMapObject(polygonSeries.getPolygonById(this.country_zoomed));
        });

      }

    }
  },
  mounted() {
    this.GetCountry()
    this.renderChart()
  }
}

</script>
